<template>
	<div>
		<o-section title="Commander un pack de signatures">
			<h4>{{ 'Agence'.pluralize(balance.companyNames.length) }}d'emploi</h4>
			<div class="balance__company-list">
				<o-label
					v-for="(companyName, i) in balance.companyNames"
					:key="i"
					outline>
					{{ companyName }}
				</o-label>
			</div>

			<o-select
				v-model="setup.selectedPack"
				label="Sélectionnez un pack de signature"
				:options="setup.listPacks"/>

			<o-textarea
				v-model="setup.comment"
				label="Commentaire"/>
		</o-section>
		<o-section align="stretch">
			<o-button
				color="danger"
				outline
				@click="_aside?.close()">
				Annuler
			</o-button>
			<o-button
				color="info"
				@click="setup.sendOrderAsync()">
				Envoyer la commande
			</o-button>
		</o-section>
	</div>
</template>

<script setup lang="ts">
import DashboardSignatureOrderAsideSetupService from '@/setup/dashboard/DashboardSignatureOrderAsideSetupService';
import { inject } from 'vue';
const _aside = inject<OrionAside>('_aside');
const props = defineProps(DashboardSignatureOrderAsideSetupService.props);
const setup = new DashboardSignatureOrderAsideSetupService(props, _aside);
</script>
